/**
 * Keep grantee directory details panels open on desktop.
 *
 * The desktop design uses the same editable content as the mobile accordion,
 * but browsers do not reliably paint children inside a closed native details
 * element. Toggling the open attribute at the breakpoint keeps mobile native
 * accordion behavior while making desktop render as simple list columns.
 *
 * @returns {void}
 */
export function initGranteeDirectoryAccordion() {
	const panels = document.querySelectorAll( '.grantee-directory-accordion-panel' );

	if ( panels.length === 0 ) {
		return;
	}

	const desktopQuery = window.matchMedia( '(min-width: 992px)' );

	const syncPanelState = function () {
		panels.forEach( function ( panel ) {
			if ( desktopQuery.matches ) {
				panel.setAttribute( 'open', '' );
				return;
			}

			panel.removeAttribute( 'open' );
		} );
	};

	syncPanelState();
	desktopQuery.addEventListener( 'change', syncPanelState );
}
